import { render, staticRenderFns } from "./ReceiptPage.vue?vue&type=template&id=965c6b5a&scoped=true&"
import script from "./ReceiptPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPage.vue?vue&type=style&index=0&id=965c6b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965c6b5a",
  null
  
)

export default component.exports